import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';

import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import AccountAssetsCard from './AccountAssetsCard';
import AccountOpportunitiesCard from './AccountOpportunitiesCard';

export default function AccountRelatedPage() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { data: account } = useGetAccount(accountId);

  return (
    <>
      <Helmet>
        <title>Related | {account?.name || accountId}</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 1 }}>
        Related
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Opportunities and assets on this Salesforce Account.
      </Typography>

      <Stack spacing={3}>
        <AccountOpportunitiesCard accountId={accountId} />
        <AccountAssetsCard accountId={accountId} />
      </Stack>
    </>
  );
}
